import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async showcase => { // 'comp-glue[showcase]'
	const 	aspect = showcase.querySelector('comp-background').getAttribute('aspect'),
			toggleEls = [...showcase.querySelectorAll(':scope > *:not(comp-background)')].filter( element => !element.matches('comp-background + *'));

	showcase.querySelector(':scope > * > comp-container:not([crop]) > inner-content').appendChild(h('button class="show more text"').Node);

	toggleEls.forEach(element => {
		element.classList.add('collapsed');
		element.classList.add('collapsible');
	});

	domWrap(showcase).on('click','button.show', function(){
			if(this.classList.contains('more')){
				toggleEls.forEach(element => element.classList.remove('collapsed'));
			}
			else {
				toggleEls.forEach(element => element.classList.add('collapsed'));
			}
			this.classList.toggle('more');
			this.classList.toggle('less');
	});
};